import React, {useState} from "react";
import "./index.scss";
import Select from "features/components/select";
import {TextField} from "features/components/text-field";
import {bool, func, string} from "prop-types";
import {__} from "services/i18n";
import {COMPANY_ADDRESS_TYPES} from "constants.js";
import Button from "features/components/button";

const CompanyAddressForm = (props) => {
    const {onChange, showDeleteButton, onDelete} = props;
    const [typeVal, setType] = useState(props.type);
    const [addressVal, setAddress] = useState(props.address);
    const [zipVal, setZip] = useState(props.zip);
    const [provinceVal, setProvince] = useState(props.province);
    const [countryVal, setCountry] = useState(props.country);

    React.useEffect(() => {
        onChange({
            type: typeVal,
            address: addressVal,
            zip: zipVal,
            province: provinceVal,
            country: countryVal
        })
    }, [onChange, typeVal, addressVal, zipVal, provinceVal, countryVal]);

    return <div className="company-address-form">
        <div className="form-field">
            <Select
                value={typeVal}
                values={COMPANY_ADDRESS_TYPES}
                onChange={setType}
                placeholder={__("text-fields.company-address-type.placeholder")}
            />
            <TextField
                type={"text"}
                value={addressVal}
                onChange={setAddress}
                placeholder={__("text-fields.full-address.placeholder")}
            />
        </div>
        <div className="form-field triple">
            <TextField
                type={"text"}
                value={zipVal}
                onChange={setZip}
                placeholder={__("text-fields.zip.placeholder")}
            />
            <TextField
                type={"text"}
                value={provinceVal}
                onChange={setProvince}
                placeholder={__("text-fields.province.placeholder")}
            />
            <TextField
                type={"text"}
                value={countryVal}
                onChange={setCountry}
                placeholder={__("text-fields.country.placeholder")}
            />
        </div>
        {showDeleteButton && <Button title={__("buttons.delete-company-address")} onClick={onDelete} status={"danger"} />}
    </div>
};
CompanyAddressForm.propTypes = {
    address: string,
    type: string,
    zip: string,
    province: string,
    country: string,
    onChange: func.isRequired,
    showDeleteButton: bool,
    onDelete: func
};

export const CompanyAddressFormBaseState = {
    address: "",
    type: "",
    zip: "",
    province: "",
    country: ""
}

export default CompanyAddressForm;